module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/core-js/library/modules/_iter-step.js
// module id = 1265
// module chunks = 3